import { combineReducers } from 'redux';
import menu from './menuReducer';
import auth from './authReducer';
import menuPRTR from './menuPRTRReducer';
import lookupitems from './lookupitemsReducer';
import { reducer as permissions } from 'react-redux-permissions';

export default combineReducers({
  menuPRTR,
  menu,
  auth,
  permissions,
  lookupitems,
});



// WEBPACK FOOTER //
// ./src/@redux/reducers/index.js